import { render } from "./examinationDifficultPie.vue?vue&type=template&id=a51de0de&scoped=true"
import script from "./examinationDifficultPie.vue?vue&type=script&lang=js"
export * from "./examinationDifficultPie.vue?vue&type=script&lang=js"

import "./examinationDifficultPie.vue?vue&type=style&index=0&id=a51de0de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a51de0de"]])

export default __exports__